'use client'

import { ArrowLeft } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { useRouter } from 'next/navigation'
import type { ReactElement } from 'react'

import { Button } from '@/components/ui/button'

export function NotFoundGoBackButton(): ReactElement {
  const router = useRouter()
  const t = useTranslations('NotFound')

  return (
    <Button
      type="button"
      variant="outline"
      size="default"
      className="w-full sm:w-fit"
      onClick={() => {
        router.back()
      }}
    >
      <ArrowLeft className="size-4" aria-hidden />
      {t('goBack')}
    </Button>
  )
}
